export enum SidebarItemKey {
  DASHBOARD = 'dashboard',
  NEWS = 'news',
  WIKIS = 'wikis',
  PROCESSES = 'userProcess',
  ADMIN_PROCESSES = 'processes',
  ADMIN_WIKIS = 'adminWikis', // This would be refactored after API integration
  FILES = 'files',
  CONTENT_CATEGORIES = 'contentCategories',
  QUICKLINKS = 'quicklinks',
  LANGUAGES = 'languages',
  TICKET_OVERVIEW = 'ticketOverview',
  TICKET_MANAGEMENT = 'ticketManagement',
  SEARCH_KEYWORDS = 'searchKeywords',
}
